// Drives the Google Translate widget loaded in public/index.html. Its
// hidden <select class="goog-te-combo"> is the widget's own language
// picker — flipping its value and firing a change event is how every
// site with a custom translate UI switches Google's translation without
// showing Google's own dropdown.
export const changeGoogleTranslateLanguage = (langCode) => {
  const select = document.querySelector('.goog-te-combo');
  if (select) {
    select.value = langCode;
    select.dispatchEvent(new Event('change'));
    return;
  }

  // Widget script hasn't finished mounting yet (e.g. right after first
  // load) — googtrans is Google Translate's own cookie for picking up a
  // language on page load, so set it and reload as a fallback.
  document.cookie = `googtrans=/en/${langCode}; path=/`;
  window.location.reload();
};
